import { ErroDoServidorPontotel } from 'src/tipos/erros/classes'
import i18n from '@/typescript/servicos/i18n/i18n.servico'

export class ErroRespostaHTTPInvalida extends ErroDoServidorPontotel {
  constructor () {
    super(i18n.t('tipos.erros.servidor.erroInesperado').toString())
  }
}
